import { apiSlice } from "core/api";
import { makeCrudEndpoints } from "common/api/apiHelpers";
import type { Sonometer } from "sonometer/types/sonometer.model";

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"Sonometer", Sonometer>(
    "Sonometer",
    "sonometers" // Try singular instead of plural
  ),
});

export const {
  useGetSonometerQuery,
  useListSonometersQuery,
  useAddSonometerMutation,
  useRemoveSonometerMutation,
  useUpdateSonometerMutation,
} = api;
